import { Routes, Route } from "react-router-dom";

import Nav from "./components/Nav.jsx";
import ConfigBanner from "./components/ConfigBanner.jsx";

import Landing from "./features/claim/Landing.jsx";
import ClaimFlow from "./features/claim/ClaimFlow.jsx";
import ClaimFinish from "./features/claim/ClaimFinish.jsx";
import AuthFinish from "./features/auth/AuthFinish.jsx";
import SignIn from "./features/auth/SignIn.jsx";
import Dashboard from "./features/dashboard/Dashboard.jsx";
import EventResponses from "./features/dashboard/EventResponses.jsx";
import EventSubscribers from "./features/dashboard/EventSubscribers.jsx";
import Editor from "./features/wizard/Editor.jsx";
import Published from "./features/dashboard/Published.jsx";
import InviteViewer from "./features/brochure/InviteViewer.jsx";

// Routes that show the app chrome (nav). The public invite (/:slug) renders the
// brochure full-bleed without chrome. In production the SSR function serves
// /:slug; the SPA route here is the dev/SPA-nav fallback.
function Chrome({ children }) {
  return (
    <>
      <Nav />
      <ConfigBanner />
      {children}
    </>
  );
}

export default function App() {
  return (
    <Routes>
      {/* App / authoring surface */}
      <Route path="/" element={<Chrome><Landing /></Chrome>} />
      <Route path="/app" element={<Chrome><Dashboard /></Chrome>} />
      <Route path="/app/signin" element={<Chrome><SignIn /></Chrome>} />
      <Route path="/app/claim/:slug" element={<Chrome><ClaimFlow /></Chrome>} />
      <Route path="/app/claim/:slug/finish" element={<Chrome><ClaimFinish /></Chrome>} />
      <Route path="/app/responses/:slug" element={<Chrome><EventResponses /></Chrome>} />
      <Route path="/app/subscribers/:slug" element={<Chrome><EventSubscribers /></Chrome>} />
      <Route path="/app/edit/:slug" element={<Chrome><Editor /></Chrome>} />
      <Route path="/app/published/:slug" element={<Chrome><Published /></Chrome>} />
      <Route path="/auth/finish" element={<AuthFinish />} />

      {/* Public invite (full-bleed, no chrome) */}
      <Route path="/:slug" element={<InviteViewer />} />
    </Routes>
  );
}
